import React from 'react'
import { useUserImage } from 'shared/hooks/useUserImage'
import { IPersonalDetails } from 'types/interfaces/IPersonalDetails'
import { StyledImage, StyledImageContainer } from './style'
import { Relationships } from 'store/api-slices/userSlice'

interface FavoritePlayerImageProps {
  userDetails?: IPersonalDetails
  relationshipDetails?: Relationships
}

const FavoritePlayerImage: React.FC<FavoritePlayerImageProps> = ({
  userDetails,
  relationshipDetails,
}) => {
  const prorToUse = userDetails ? userDetails : relationshipDetails
  const userImage = useUserImage(prorToUse)

  return (
    <StyledImageContainer>
      <StyledImage src={userImage} alt="user-profile" />
    </StyledImageContainer>
  )
}

export default FavoritePlayerImage
